
<div class="global-container"
    (wheel)="global_onWheel($event)">

    <!-- Left row - Canvas --> 
    <div #canvasElement_Container class="left-container">
        <div #canvasElement_InnerContainer class="canvas-container">
            <canvas 
                #canvasElement 
                class="canvas-image"
                (contextmenu)="canvas_onRightClick($event)"
                style="z-index: 1;">
            </canvas>
            <canvas 
                #canvasElement_Overlay 
                class="canvas-image"
                (contextmenu)="canvas_onRightClick($event)"
                style="z-index: 2;">
            </canvas>
        </div>        
    </div>
    <!-- Right row - Buttons --> 
    <div class="right-container">
        <!-- Cursor appearence -->
        <div class="right-section-container-cursor-buttons">
            <!-- Button - Cursor - Circle/Square -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="updateCursorShape()">
                <span class="hollow-square" *ngIf="this.cursorShape == 0"></span> 
                <span class="hollow-circle" *ngIf="this.cursorShape == 1"></span> 
            </button>
            <!-- Button - Cursor - Decrease size (-) -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="updateCursorSize(-1)">
                &#8722;
            </button>
            <!-- Button - Cursor - Increase size (+) -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="updateCursorSize(+1)">
                &#43;
            </button>
        </div>
        <!-- Class selector -->
        <div class="right-section-container" style="height: 50px;">
            <!-- Button - Open Mat menu - Process -->
            <button 
                mat-raised-button   
                color="primary"
                class="base_buttons button_with_icon"
                [matMenuTriggerFor]="menuClasses" 
                >
                    {{className}}
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #menuClasses="matMenu" yPosition="below">
                <button mat-menu-item *ngFor="let item of classes"
                (click)="setActiveClass(item.id)" >
                    {{item.name}}
                </button>
            </mat-menu>
        </div>
        <!-- Zoom actions -->
        <div class="right-section-container-cursor-buttons">
            <!-- Button - Zoom in -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="updateZoom(+1)">
                <mat-icon>zoom_in</mat-icon>
            </button>
            <!-- Button - Zoom out -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="updateZoom(-1)">
                <mat-icon>zoom_out</mat-icon>
            </button>
        </div>
        <div class="right-section-container-cursor-buttons">
            <!-- Button - Keyboard arrow up -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="moveWithButtons(0, -1)">
                <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <!-- Button - Keyboard arrow down -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="moveWithButtons(0, +1)">
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
            <!-- Button - Keyboard arrow left -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="moveWithButtons(-1, 0)">
                <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <!-- Button - Keyboard arrow right -->
            <button 
                mat-raised-button   
                color="primary"
                class="icon-button"
                (click)="moveWithButtons(+1, 0)">
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>

        <div class="right-section-container">
            <div class="base_buttons_container">
                <!-- Exit button --> 
                <button mat-raised-button 
                        color="primary"
                        class="base_buttons"
                        (click)="exitButtonClicked()"
                        style="width: 47%;">
                    {{languageService.Strings.buttons.button_exit}}
                </button>  
                <!-- Save button -->        
                <button mat-raised-button 
                    color="primary"
                    class="base_buttons" 
                    (click)="saveButtonClicked()" 
                    style="width: 47%;" 
                    [disabled]="!unsavedChanges"> 
                    {{languageService.Strings.buttons.button_save}}
                </button>   
            </div>
        </div>
    </div>
</div>

